exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".letra {\n  font-size: 0.6em;\n  line-height: 1.0;\n  color:white;\n}\n\n.menu-user {\n  margin: 0;\n  min-width: 0;\n  padding: 30px;\n}\n\n.sidenav-menu-item {\n  margin: 0;\n  font-size: 15px;\n  padding-left: 1em;\n  cursor: pointer;\n}\n\n.menu-item {\n  background-color: none;\n  transition: 0.5s;\n  color: white;  \n}\n\n.menu-item:hover {\n  background-color: white;\n  color: black;\n  cursor: pointer;\n}\n\ndiv.cdk-focus-trap-content{\n  overflow: hidden !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GIT/F260V3/ingreso/ng_ingresosimple260/Simple260Ingreso/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main